<template>
  <div class="kst-pageprintdetails" :class="theClass" :style="theStyle">
    <template v-if="reloadAreaVisible">
      <div class="mb-0 px-4 py-2 ks-border-b-light ks-print-hidden">
        <div class="buttons is-justify-content-end">
          <kst-button slim-size reload-mode @click="handleReload"/>

          <template v-if="printVisible">
            <kst-button slim-size print-mode @click="handlePrint"/>
          </template>
        </div>
      </div>
    </template>

    <div class="kst-pageprintdetails__content p-4">
      <kst-skeleton :active="isLoading"/>

      <template v-if="defaultSlotVisible">
        <slot />

        <template v-if="pageFooter">
          <slot name="page-footer"
            :label="labelPageFooter"
            :timestamp="timestamp"
          >
            <div class="mt-2">
              {{ labelPageFooter }} {{ timestamp }}
            </div>
          </slot>
        </template>
      </template>

      <kst-failure init-mode :items="failureInit"/>
    </div>
  </div>
</template>

<script>
import AppCatalog from "../../../services/App/AppCatalog.js";
import AxiosMixin from "../../../mixins/AxiosMixin.js";
import LoadingMixin from "../../../mixins/LoadingMixin.js";
import RouterMixin from "../../../mixins/RouterMixin.js";

/**
 * flow (how to use):
 * 1. handle Init event and do loadPrint
 * 2. handle loadPrint success-callback
 */
export default {
  mixins: [AxiosMixin, LoadingMixin, RouterMixin],
  props: {
    pageFooter: Boolean,
    width: Number
  },
  data: () => ({
    userData: {
      ID: null // required
    },
    printVisible: false,
    // loading
    isLoading: true,
    // area
    reloadAreaVisible: false,
    // slot
    defaultSlotVisible: false,
    // error
    failureInit: null
  }),
  computed: {
    labelPageFooter() {
      return AppCatalog.Print.PrintedAt;
    },
    module() {
      return this.$route.meta.module;
    },
    moduleType() {
      return this.$route.meta.moduletype;
    },
    timestamp() {
      return this.$kst.View.getTimestamp();
    },
    theClass() {
      return this.$kst.Vue.getComponentClass(this.module, this.moduleType);
    },
    theStyle() {
      return this.width ? "width: " + this.width + "px" : undefined;
    }
  },
  created() {
    this.init();
  },
  methods: {
    /*** page template ***/

    init() {
      this.init_Data();
      if (this.init_Validate()) {
        this.$emit(this.$kst.Enum.Event.Init,
          this.userData.ID,
          this.loadPrint,
          this.showFailureInit
        );
      }
    },
    init_Data() {
      this.userData.ID = null;
      this.printVisible = false;
      // loading
      this.isLoading = true;
      // area
      this.reloadAreaVisible = false;
      // slot
      this.defaultSlotVisible = false;
      // error
      this.failureInit = null;
    },
    init_Validate() {
      // check: required url params
      this.userData.ID = this.getUrlParam(this.$kst.Enum.Param.ID);

      if (!this.userData.ID) {
        this.failureInit = [AppCatalog.Message.ParamIncomplete];
        this.init_Failed();
        return false;
      }

      return true;
    },
    init_Success() {
      this.isLoading = false;
      this.printVisible = true;
      this.reloadAreaVisible = true;
      this.defaultSlotVisible = true;
    },
    init_Failed() {
      this.isLoading = false;
      this.reloadAreaVisible = true;
    },

    handleReload() {
      this.init();
    },

    /*** custom ***/

    loadPrint(config, successCallback) {
      this.runAxios(config, successCallback,
        this.loadPrint_Success,
        this.loadPrint_Fault,
        this.loadPrint_Fault,
        null, true
      );
    },
    loadPrint_Success(data, successCallback) {
      successCallback(data);
      this.init_Success();
    },
    loadPrint_Fault(message) {
      this.failureInit = message;
      this.init_Failed();
    },

    handlePrint() {
      window.print();
    },

    showFailureInit(message) {
      this.failureInit = message;
      this.isLoading = false;
    }
  }
}
</script>